// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/Images/search_lens.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%2367768a%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27><path d=%27M7 10l5 5 5-5%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --admin-button-color: #0d6efd;
  --warning-color: #ff2323;
  --alert-color: #f8ff87;
  --green-color: #00c07b;
}

.warningColor {
  color: var(--warning-color) !important;
}

.alertColor {
  color: var(--alert-color) !important;
}

.alertColorBg {
  background-color: var(--alert-color) !important;
}

.warningColorBg {
  background-color: var(--warning-color) !important;
}

.greenColorBg {
  background-color: var(--green-color) !important;
}

body {
  font-family: "Poppins" !important;
  background-color: #f0f0f0 !important;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #424242;
}

.card {
  box-shadow: none !important;
  border: none !important;
}

.iq-card {
  box-shadow: none !important;
}

button,
p,
input,
label,
span {
  font-family: "Poppins";
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins" !important;
}

a {
  text-decoration: none !important;
}

/* Style for the dropdown container */
.editdropdown {
  position: relative;
  display: inline-block;
  /* z-index: 9; */
}

/* Style for the dropdown button */
.editdropdown-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdown-menu {
  display: none;
  left: -163px;
  top: 0;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 190px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdown:hover .editdropdown-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdown-menu a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.mandatory {
  color: red;
}

.mandatorySimple::after {
  content: "*";
  color: red;
}

.jodit_sticky>.jodit-toolbar__box {
  position: inherit !important;
}

/* Highlight dropdown menu items on hover */
/* Style for the dropdown container */
.editdropdownpage {
  position: relative;
  display: inline-block;
}

/* Style for the dropdown button */
.editdropdownpage-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdownpage-menu {
  display: none;
  left: -93px;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdownpage:hover .editdropdownpage-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdownpage-menu a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.mandatory {
  color: red;
}

.notificationofwednesday {
  position: fixed;
  width: 100%;
  z-index: 9999;
  background: black;
  color: white;
}

/* Highlight dropdown menu items on hover */
.editdropdownpage-menu a:hover {
  background-color: #f1f1f1;
}

.green-color {
  color: #d3ffd3;
}

.green-color-bg {
  background-color: #d3ffd3;
}

.yellow-color {
  color: #fff8a6;
}

.dark-green {
  color: green;
}

.PUBLISHED_active {
  background: #d3ffd3;
  color: green;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.UNPUBLISHED_active {
  background: #ffd9d9;
  color: red;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.ACTIVE_active {
  background: #d3ffd3;
  color: green;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.In-ACTIVE_active {
  background: #ffd9d9;
  color: red;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.DISABLED_active {
  background: #ffea008a;
  color: #000000;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.tabHeading {
  font-family: "museo_sans500" !important;
  font-style: normal;
  font-size: 16px !important;
  color: #424242 !important;
  background-color: transparent;
  position: relative;
  display: block;
}

.tabHeading.active {
  font-family: "museo_sans700" !important;
}

.tabHeading.active::after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: -9px;
  left: 0;
  border-radius: 10px;
  height: 4px;
  background-color: rgb(77, 77, 247);
}

.dashboard a {
  text-decoration: none;
  font-size: 16px;
}

.dashboard p {
  color: #000000;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-transform: capitalize;
  color: #161616;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  color: #646464;
}

.liveAlert.alert.alert-success.alert-dismissible.fade.show {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
}

.liveAlert.alert.alert-danger.alert-dismissible.fade.show {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
}

.banner-slider .modal {
  top: 50px;
}

.delete_confirm {
  margin-top: 10rem;
}

.success-message i {
  font-size: 50px;
  background-color: transparent;
  border-radius: 50px;
  border: 2px solid greenyellow;
  color: greenyellow;
}

.css-1u9des2-indicatorSeparator {
  width: 0px !important;
}

select {
  height: 50px;
}

.css-1xc3v61-indicatorContainer {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  padding: 0px !important;
  box-sizing: border-box;
}

.css-15lsz6c-indicatorContainer {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  /* padding: 0px !important; */
  box-sizing: border-box;
}

.css-t3ipsp-control {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  padding: 0px !important;
  box-sizing: border-box;
}

.css-1xc3v61-indicatorContainer svg {
  width: 30px !important;
  height: 15px !important;
  top: 14px !important;
}

.css-15lsz6c-indicatorContainer svg {
  width: 18px !important;
  height: 18px !important;
}

.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg {
  position: absolute;
  right: 10px;
  top: 11px;
}

.css-b62m3t-container {
  /* height: 50px; */
  /* border: 1px solid #e5e5ea !important; */
  border-radius: 5px;
  align-items: center;
  padding: 5px 0 5px 0;
}

.css-13cymwt-control {
  min-height: 45px !important;
}

.thumbnails-images {
  width: auto;
  height: 100px;
}

.thumbnails-upload-images {
  width: 100%;
  height: 65px;
}

#publish_time {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: transparent !important;
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: transparent !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid #e5e5ea !important;
  height: 50px;
}

/* overlay.css */
.overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-icon {
  font-size: 25px;
  color: white;
}

.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg {
  position: absolute;
  right: 0px;
  top: 11px;
}

.css-1fdsijx-ValueContainer {
  padding: auto !important;
}

.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg path[d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"] {
  display: none;
}

.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg path[d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"] {
  display: none;
}


th {
  text-align-last: start !important;
  padding: 0;
}

td {
  text-align-last: start !important;
  padding: 0;
}

/* New Header siderbar 28/8/2023 */
/* New Header siderbar 28/8/2023 */
/* Mobile view  */
/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
  .footerlink {
    font-size: 15px;
    padding: 0;
    margin: 0;
  }
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {}

/* old codes */

.errorred {
  color: #ff2c2c !important;
  font-size: 14px;
  font-weight: 600;
}

.errorredspan {
  position: absolute;
  bottom: -18px;
}

.imageForm {
  display: block;
  position: absolute;
  right: 16px;
  z-index: 1;
  bottom: 11px;
  width: 80px;
  height: 37px;
  object-fit: cover;
}

#nestable>table {
  overflow-x: auto;
}

.approveTable>table {
  overflow-x: auto;
}

#videoPlayer {
  width: 100%;
  height: 100%;
}

.editVideoPlayer {
  width: 125px !important;
  height: 75px;
}

.status {
  width: 80%;
  font-weight: bold;
  margin: 0 auto;
  border-radius: 4px;
}

.closeBtn {
  position: absolute !important;
  right: 0;
  top: 0px;
  width: 40px;
  background: transparent;
  z-index: 100 !important;
  height: 60px;
}

#PendingvideoPlayer {
  width: 100%;
  height: 80px;
}

.exportIcon {
  width: 22px;
  height: 18px;
}

input[type="checkbox"]:checked+label::before {
  background-color: #00f;
  border-color: #00f;
}

.idClass {
  width: 80px !important;
}

.page-link {
  transition: none !important;
}

.page-link:focus {
  box-shadow: none !important;
}

.view-search {
  background: rgba(250, 250, 250, 1);
  border: 1px solid transparent;
  height: 45px;
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  padding-left: 10px;
  color: #646464 !important;
}

.filterContainer {
  max-width: 270px;
  width: 100%;
  position: relative;
}

.hiddenExport {
  display: none !important;
}

.video-overall-progress-li li {
  list-style-type: none !important;
}

.filter:focus {
  box-shadow: none !important;
}

select#rating {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}


select#trailer_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#access {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#url_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#parent_id {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#artist_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#role_id {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

li {
  list-style-type: none;
}

.form-control.filter {
  max-width: 270px;
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: 11px 13px;
  padding: 8px 37px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transition: none !important;
}

.totalText {
  /* font-family: "museo_sans700" !important; */
  font-family: "Poppins" !important;
  font-style: normal;
  color: #424242 !important;
  font-size: 20px;
}

/* Shared Icon Positioning for Inputs */
.lockIcon,
.eyeOpen,
.eyeClosed {
  font-size: 18px;
  color: #000;
}

.lockIcon {
  top: 15px;
  left: 10px;
}

.passWordIcon {
  top: 15px;
  right: 17px;
}

.react-bootstrap-table th.sortable {
  position: relative;
}

.react-bs-table-no-data {
  text-align: center;
}

.commonActionPadding {
  padding: 12px 16px;
  cursor: pointer;
}

.modal.packageModel {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9997;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background-color: rgb(0 0 0 / 41%);
}

.modal.season.packageModel {
  z-index: 9996 !important;
}

.packageModel .btn-close:focus {
  box-shadow: none;
}

.noRecord {
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
  padding: 10px;
}

.dropzone {
  background-position: left;
  background-size: 75% !important;
  background-repeat: no-repeat;
  justify-content: flex-end !important;
}

.editFormImage {
  max-width: 170px !important;
  height: 100px;
  object-fit: contain;
  display: block;
  margin: 8px 0px;
}

.videoPreview {
  width: 80%;
  margin-right: auto;
  height: 100%;
}

.Toastify__toast {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 12px 16px !important;
  min-height: 56px !important;
}

.Toastify__toast-body {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding: 0 12px !important;
}

.Toastify__toast-icon {
  width: 22px !important;
  margin-inline-end: 12px !important;
}

.Toastify__progress-bar {
  height: 3px !important;
}

.admin-sub-title {
  font-family: "Poppins";
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  word-wrap: break-word;
}

.admin-sub-title {
  font-family: "Poppins";
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  word-wrap: break-word;
}

.bootstrapTable table>thead>tr {
  border: none;
}

.bootstrapTable table>thead>tr>th {
  border: none;
  font-size: 16px;
  font-family: "Poppins" !important;
  padding: 10px;
  width: 130px;
  font-weight: 500;
  position: relative;
}

.bootstrapTable table>tbody>tr>td {
  white-space: normal;
  word-break: break-all;
  border: none;
  font-size: 15px;
  font-family: "Poppins" !important;
  padding: 10px;
  width: 130px;
  vertical-align: middle;
}

.bootstrapTable.multi-delete-width table>thead>tr>th:nth-child(1) {
  width: 4%;
}

.bootstrapTable .video-width-table {
  width: 200px;
}

.bootstrapTable .page-item.disabled>.page-link {
  opacity: 0.5;
}

.videoWidth>th:nth-child(2) {
  width: 30%;
  position: relative;
}

.videoWidthpartner>th:nth-child(2) {
  width: 10%;
  position: relative;
}

.videoWidth>th:nth-child(2) span {
  position: absolute;
  right: 0;
}

.videoWidth>th {
  width: 100px;
}

.sortable::after {
  content: "\\2193";
  color: #ccc;
  padding: 0px 9px;
  position: absolute;
  right: 12px;
  top: 3px;
  font-size: 18px;
}

.sortable::before {
  content: "\\2191";
  color: #ccc;
  position: absolute;
  right: 12px;
  top: 3px;
  font-size: 18px;
}

th[aria-label="Audios sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Audios sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Access sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Access sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Videos sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Videos sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Upload by sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Upload sort desc"].sortable::after {
  color: #fff;
}

.profile {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 3px;
}

.table-subheading {
  font-size: 12px;
}

.rightVideoTitle {
  width: 200px;
}

.sliderBtnText {
  font-size: 13px !important;
  font-family: "Poppins" !important;
}

.admin-button-text {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 20px !important;
}

.button-color {
  color: #fff !important;
}


.admin-input-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.svgIcon {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.75px;
}

.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-menu {
  bottom: 32px;
}

.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-item>a {
  display: block;
}

#pageDropDown {
  transition: none !important;
}

#pageDropDown:focus {
  box-shadow: none !important;
}

.react-bootstrap-table-page-btns-ul {
  justify-content: end;
}

.clearBtn {
  top: 10px;
  position: absolute;
  right: 0;
  background: transparent;
}

.custom-close-btn {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.adminHeadContainer {
  min-height: calc(100vh - 120px);
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: all 0.4s;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: all 0.4s;
}

input:checked+.slider:before {
  left: 26px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-placeholder::placeholder {
  font-family: "Poppins" !important;
}

.imagedropcopy {
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  cursor: pointer;
  min-height: 70px;
  height: auto;
  width: 80%;
}

.imagedropcopyimage {
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  width: 100%;
  cursor: pointer;
}

.admin-title {
  font-size: 30px;
  line-height: 40px;
  font-weight: bold;
}

.customDropWrapper {
  width: 100%;
  height: 250px;
  border: 2px dashed #ccc;
  position: relative;
}

.customDropWrapper input {
  opacity: 0;
}

.dropZoneText {
  position: absolute;
  top: 0;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 100%;
}

.rowCheckboxDrag {
  width: 4% !important;
}

.rowCheckboxfooterDrag {
  width: 9% !important;
}

.category-order-title {
  padding: 10px;
  font-size: 16px;
  white-space: normal;
  word-break: break-all;
  border: none;
}

.border-width {
  border-width: 2px !important;
}

.border-solid-width {
  border-width: 1px;
}

.orderHeading {
  font-size: 16px;
  font-weight: bold;
  line-height: 37px;
  font-family: 'Poppins';
}

.orderContainer>div:not(:nth-child(2), :nth-child(1), :nth-child(4)) {
  width: 15%;
}

.orderContainer>div:nth-child(1) {
  width: 5%;
}

.orderContainer>div:nth-child(2) {
  width: 25%;
}

.orderContainer>div:nth-child(4) {
  width: 15%;
}

.reloadButton {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-tool-tip-parent {
  position: relative;
}

.custom-tool-tip-parent:hover .custom-tool-tip {
  display: block !important;
}

.cursor-pointer {
  cursor: pointer;
}

.modal-description {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.imagedrop {
  /* width: 100%; */
  width: 80%;
  height: 70px;
  /* height: 120px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  cursor: pointer;
}

.image-close {
  position: absolute;
  top: -16px;
  right: -14px;
  width: 22px !important;
  height: 22px !important;
  opacity: 1 !important;
  border-style: dashed !important;
  border-width: 2px !important;
  border-color: #cbd5e1 !important;
}

.custom-input {
  font-size: 13px;
  padding: 15px 20px;
  border-radius: 7px;
  font-weight: 500;
}

input[readonly]:focus {
  outline: none;
}

.focus-hide:focus {
  outline: 0;
}

.rti--container {
  padding: 11px 15px !important;
}

.rti--tag>span {
  padding: 4px 15px;
  border-radius: 2px;
}

.rti--tag>button {
  padding: 3px 5px !important;
  border-radius: 0px !important;
}


.admin-input-description {
  font-size: 13px;
  min-width: 80px;
}

.copy-board-container {
  cursor: pointer;
  position: absolute;
  top: -1px;
  width: 55px;
  right: -1px;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
  height: 51px;
}

.copy-board-input {
  padding-right: 55px;
}


.copy-reply {
  top: -45px;
  right: 6px;
}

.tool-tip-text {
  top: -44px;
  padding: 10px;
  left: 136px;
  font-size: 10px;
  border-radius: 6px;
  width: 180px;
  line-height: 15px;
}

.tool-tip-open:hover .tool-tip-text {
  display: block !important;
}

.labelLoader {
  width: 30%;
  height: 20px;
  border-radius: 3px;
}

.headingLoader {
  width: 50%;
  height: 35px;
  border-radius: 3px;
}

.subHeadingLoader {
  width: 40%;
  height: 14px;
  border-radius: 3px;
}

.square {
  background: rgba(130, 130, 130, 0.2);
  background: linear-gradient(to right,
      rgba(130, 130, 130, 0.2) 8%,
      rgba(130, 130, 130, 0.3) 18%,
      rgba(130, 130, 130, 0.2) 33%);
  background-size: 800px 100px;
  animation: wave-squares 2s infinite ease-out;
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.cancal-position {
  top: 2px;
  right: 5px;
}

.cancal-position>svg {
  width: 15px;
  height: 15px;
}

.progressHeight {
  height: 30px;
}

.percentagePop {
  top: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 20px;
  height: 10px;
  border: 0;
}

.progressSmall {
  height: 15px;
}

.progressSubText {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 3px;
}

.progressButton {
  font-size: 10px;
  padding: 3px 13px;
}

.percentageText {
  top: 0px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 11px;
  width: 20px;
  height: 14px;
  border: 0;
}

.progressFileNameElip {
  width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-large {
  max-width: 800px !important;
}

.priceTable {
  height: 300px;
  overflow-y: overlay;
}

.priceTable thead {
  position: sticky;
  top: 0;
}

.AdminUploadIndicator {
  position: fixed;
  bottom: 50px;
  right: 10px;
  width: 400px;
  z-index: 998;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  height: auto;
  max-height: 450px;
  transition: height 1s ease;
}

.overflow-scroll-indicator {
  overflow: hidden overlay;
}

.overflow-hidden-indicator {
  overflow-x: hidden !important;
}

.upload-indicator-header {
  top: 0;
  z-index: 998;
}

.AdminUploadIndicator.collapse-zone {
  height: 50px;
}

.indicator-width {
  width: 200px;
}

.successFull {
  background-color: #3cb043;
}

.indicator-file-name {
  width: 200px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.indicatorButon {
  width: 58px;
}

.list-height {
  height: 68px;
}

.cancelText {
  font-size: 10px;
}

.sizeText {
  font-size: 10px;
  font-weight: bold;
}

.speedText {
  font-size: 10px;
  font-weight: 600;
}

.border-solid {
  border-style: solid;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.from-indicator {
  padding: 2px 9px;
  font-size: 8px;
  top: -11px;
  left: -2px;
  background-color: rgb(241, 241, 115);
}

.galleryBox {
  height: 400px;
  overflow-y: scroll;
}

.galleryImage {
  height: 150px;
  object-fit: cover;
}

.galleryTitle {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
}

.galleryDuration {
  font-size: 11px;
  font-weight: 400;
}

.galleryButton {
  width: 30px;
  height: 30px;
}

.galleryAfter::after {
  content: '' !important;
  display: none !important;
}

.galleryCheckBox {
  position: absolute;
  top: 38px;
  left: 37px;
  height: 21px;
  width: 21px;
}

.hideArrow::after {
  border: none !important;
}

.custom-datepicker {
  width: 250;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.custom-datepicker .rs-picker-toggle-value {
  color: black !important;
}

.rs-picker-daterange-header {
  display: none !important;
}

.z-index-1 {
  z-index: 1;
}

.table-column-title.avoid-overflow-ellipsis {
  text-overflow: unset;
  overflow: unset;
  white-space: unset;
  max-width: unset;
}

@media screen and (max-width: 423px) {
  .deleteBtn {
    width: 100%;
  }
}

.tooltip-disabled {
  font-size: 11px;
  background-color: #333;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 9999 !important;
}

.custom-page-select {
  background-color: #ffffff;
  color: #000;
}

select.select-view-type {
  width: 100px !important;
}

.admin-tooltip {
  border-radius: 6px;
  white-space: nowrap;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.tooltip-container:hover .admin-tooltip {
  pointer-events: auto;
}

.admin-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

.tooltip-container .custom-hover-tooltip {
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(10px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
  position: absolute;
  z-index: 9999;
}

.tooltip-container:hover .custom-hover-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.custom-hover-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

.trailer-episode-image {
  height: 50px;
  width: 50px;
  object-fit: cover;
}

.rtmpurleditbg :hover {
  background-color: rgb(245, 247, 252) !important;
}

.logoPay {
  width: 160px;
  height: 50px;
  object-fit: contain;
}

.drag-handle {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.modalBackdropdataserviceunavailable {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  color: #ffffff;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10007;
}

.modalContentdataserviceunavailable {
  background-color: #000000;
  color: #ffffff;
  padding: 2rem;
  opacity: 1;
  border-radius: 10px;
  max-width: 700px;
  text-align: center;
}

.hide-checkbox-row td input[type="checkbox"] {
  display: none !important;
}

.counter_timing {
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  display: inline-block;
  line-height: 1.6em;
  margin-left: 20px;
  text-align: center;
  width: 1.6em;
}


.modern-modal {
  border-radius: 20px !important;
  padding: 10px 10px 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.20);
  border: none;
}

.modern-backdrop {
  backdrop-filter: blur(4px);
}

.upgrade-btn {
  background: linear-gradient(135deg, #ff8a00, #ff4d00);
  color: #fff !important;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: 0.2s ease;
}

.upgrade-btn:hover {
  opacity: 0.9;
}

.modal-title {
  font-size: 1.25rem;
}

.sub-page {
  display: grid;
  grid-template-columns: 3fr 1.3fr;
  gap: 24px;
}

.sub-card,
.checkout-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.sub-title {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 8px;
  color: #111827;
  letter-spacing: -0.5px;
}

.sub-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.tab {
  padding: 10px 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6b7280;
  border-bottom: 2px solid transparent;
}

.tab.active {
  color: #111827;
  font-weight: 600;
  border-color: #2563eb;
}

.tab-body {
  padding-top: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.subscription-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.label {
  font-weight: 600;
  color: #374151;
}

.badge {
  background: #e5edff;
  color: #2563eb;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.status-pill {
  margin-left: auto;
  background: #dcfce7;
  color: #15803d;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.plan-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
}

.plan-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.plan-price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.price {
  font-size: 18px;
  font-weight: 600;
}

.cycle {
  font-size: 12px;
  color: #6b7280;
}

.btn-outline {
  margin-top: 8px;
  width: 100%;
  padding: 8px 0;
  border-radius: 6px;
  border: 1px solid #2563eb;
  background: #fff;
  color: #2563eb;
  cursor: pointer;
}

.checkout-card h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.total-row span:last-child {
  font-weight: 700;
}

.btn-primary.full {
  margin-top: 20px;
  width: 100%;
  padding: 10px 0;
  border-radius: 6px;
  border: none;
  background: #2563eb;
  color: #fff;
  cursor: pointer;
}

.addons-section {
  margin-bottom: 24px;
}

.plans-grid.compact {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  row-gap: 10px;
}

.pricing-card.small {
  flex: 0 0 240px;
  max-width: 240px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s ease;
}

.addons-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

.addon-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease-in-out;
}

.addon-card.purchased {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.addon-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.addon-price {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.purchased-badge {
  background: #059669;
  color: white;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.btn-outline-danger {
  margin-top: 8px;
  width: 100px;
  padding: 8px 0;
  border-radius: 6px;
  border: 1px solid #dc2626;
  color: #dc2626;
  background: #fff;
  cursor: pointer;
}

.save-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.14);
  color: #047857;
  font-weight: 600;
}

/* Existing pricing card styles (keep yours, add tweaks if needed) */
.pricing-card.small {
  width: 260px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s ease;
}

.pricing-card.small:hover {
  transform: translateY(-3px);
  border-color: #2563eb;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.07);
}

.pricing-card.small.active {
  border: 2px solid #2563eb;
  background: #eef4ff;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.plan-name {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.plan-icon {
  font-size: 22px;
  color: #9ca3af;
}

.selected-icon {
  font-size: 22px;
  color: #2563eb;
}

.price-block {
  margin-top: 10px;
}

.price-main {
  font-size: 26px;
  font-weight: 800;
}

.cycle {
  font-size: 15px;
  color: #6b7280;
  margin-left: 4px;
}

.price-strike {
  margin-top: 3px;
  text-decoration: line-through;
  color: #9ca3af;
  font-size: 15px;
}

.addon-card:hover {
  transform: translateY(-3px);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
}

.modern-select select {
  padding-left: 36px;
  border-radius: 10px;
  font-size: 15px;
}

/* Wrapper prevents clipping */
.dropdown-wrapper {
  position: relative;
  overflow: visible !important;
}

/* Dropdown container */
.custom-dropdown {
  position: relative;
  width: 220px;
}

.dd-select {
  padding-left: 40px !important;
  padding-right: 40px !important;
  border-radius: 12px !important;
  height: 42px;
  font-size: 15px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  appearance: none;
  /* Hide default arrow */
}

/* Funnel icon */
.dd-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 16px;
  pointer-events: none;
}

/* Custom arrow */
.custom-dropdown::after {
  content: "▼";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #6c757d;
  pointer-events: none;
}

/* Focus highlight */
.dd-select:focus {
  border-color: #4e74ff !important;
  box-shadow: 0 0 0 3px rgba(78, 116, 255, 0.25) !important;
}

/* Ensure dropdown never gets cut */
select {
  overflow: visible !important;
}

.dropdown-menu {
  z-index: 9999 !important;
}

.subscription-container {
  background: #ffffff;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sub-title {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.status-badge {
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 12px;
  background: #e0fbe8;
  color: #15803d;
  font-weight: 600;
}

.plan-card-modern {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9ff;
  border: 1px solid #e1e6ff;
  padding: 18px 20px;
  border-radius: 12px;
}

.plan-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 2px;
}

.plan-name {
  font-size: 20px;
  font-weight: 700;
  color: #1e3a8a;
}

.plan-tag {
  padding: 6px 14px;
  font-size: 12px;
  background: #eef2ff;
  color: #4338ca;
  border-radius: 12px;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 18px;
}

.info-item {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  padding: 14px 16px;
  border-radius: 12px;
}

.info-item.full {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  font-weight: 600;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 10px 0;
}

.checkout-card-modern {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px 22px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f2f5;
}

.checkout-title {
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 15px;
}

.checkout-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
}

.value {
  font-weight: 600;
}

.total-row .value.total {
  font-size: 18px;
  color: #111;
  font-weight: 700;
}

.divider-light {
  border-top: 1px dashed #ddd;
  margin: 10px 0;
}

.highlight-row {
  background: #f9f2ff;
  padding: 8px 10px;
  border-radius: 8px;
  font-weight: 600;
  color: #6a00ff;
}

.subtle-row {
  color: #555;
  font-size: 13.5px;
}

.next-billing-text {
  margin-top: 6px;
  font-size: 12.5px;
  color: #666;
}

.cancel-btn {
  background: #e63946;
  color: white;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
}

.cancel-btn:hover {
  background: #d62828;
}

.disabled-card {
  cursor: not-allowed !important;
  border-color: #d1d5db !important;
  pointer-events: none;
}

.disabled-card:hover {
  transform: none !important;
  box-shadow: none !important;
}

.purchased-pill {
  background: #10b981;
  color: #fff;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}

.pricing-header-v3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.pricing-title-v3 {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
}

.pricing-subtitle-v3 {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.pricing-switch-group-v3 {
  display: flex;
  align-items: center;
  gap: 15px;
}

.currency-select {
  appearance: none;
  padding: 10px 42px 10px 16px;
  font-size: 15px;
  font-weight: 600;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
  color: #0f172a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: right 12px center;
  background-repeat: no-repeat;
}

.currency-select:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.currency-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  outline: none;
}

.currency-select option {
  font-size: 15px;
  font-weight: 500;
  padding: 8px;
}

.billing-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 6px;
  gap: 6px;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
}

.toggle-btn {
  position: relative;
  z-index: 2;
  border: none;
  background: none;
  padding: 10px 26px;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  border-radius: 999px;
  white-space: nowrap;
  transition: color 0.25s ease;
}

.toggle-btn.active {
  color: #fff;
  font-weight: 700;
}

.toggle-highlight {
  position: absolute;
  top: 6px;
  bottom: 6px;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border-radius: 999px;
  box-shadow: 0px 6px 22px rgba(99, 102, 241, 0.35);
  z-index: 1;
  transition: all 0.28s ease;
}

.toggle-left {
  transform: translateX(0%);
  width: calc(50% - 6px);
}

.toggle-right {
  transform: translateX(100%);
  width: calc(50% - 6px);
}

.baseservices-section {
  padding: 30px 15px;
  max-width: 1200px;
  margin: auto;
}

.baseservices-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
}

.baseservices-subtitle {
  color: #777;
  margin-bottom: 32px;
}

.baseservices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.baseservice-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  transition: 0.3s ease;
}

.baseservice-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.1);
}

.baseservice-card h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 12px 0 10px;
}

.baseservice-card p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  flex-grow: 1;
}

.baseservice-btn-wrap {
  margin-top: 18px;
}

.baseservice-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.baseservice-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  transition: 0.3s ease;
}

.baseservice-btn .arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.baseservice-btn:hover .arrow {
  transform: translateX(6px);
}

.baseservice-btn:hover {
  color: #fff;
}

.flicknexs {
  background: #2563eb;
  color: #fff;
}

.flicknexs:hover {
  background: #2563eb;
  color: #fff;
}

.purple {
  background: #7c3aed;
}

.primary {
  background: #2563eb;
}

.warning {
  background: #f97316;
}

.dark {
  background: #111827;
}

.success {
  background: #16a34a;
}

.info {
  background: #6366f1;
}

.danger {
  background: #db2777;
}

.adminforgot .model-x-button button {
  font-size: 13px;
  right: 5px;
  top: 5px;
}


@media (max-width: 900px) {
  .sub-page {
    grid-template-columns: 1fr;
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,MAAM;EACN,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;EACtB,wEAAwE;EACxE,oCAAoC;EACpC,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,iBAAiB;AACjB,0BAA0B;AAC1B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC,4CAA4C;;AAE5C,cAAc;;AAEd;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;;AAGA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,yDAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;EAGE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EAOpC;;;mCAGiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,4CAA4C;EAC5C,kDAAkD;EAClD,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EAGE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,6CAA6C;EAC7C,cAAc;EACd,yDAAiJ;EACjJ,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,qDAAqD;EACrD,oBAAoB;EACpB,iDAAiD;EACjD,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;AACV;;;AAGA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n:root {\n  --admin-button-color: #0d6efd;\n  --warning-color: #ff2323;\n  --alert-color: #f8ff87;\n  --green-color: #00c07b;\n}\n\n.warningColor {\n  color: var(--warning-color) !important;\n}\n\n.alertColor {\n  color: var(--alert-color) !important;\n}\n\n.alertColorBg {\n  background-color: var(--alert-color) !important;\n}\n\n.warningColorBg {\n  background-color: var(--warning-color) !important;\n}\n\n.greenColorBg {\n  background-color: var(--green-color) !important;\n}\n\nbody {\n  font-family: \"Poppins\" !important;\n  background-color: #f0f0f0 !important;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: #424242;\n}\n\n.card {\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.iq-card {\n  box-shadow: none !important;\n}\n\nbutton,\np,\ninput,\nlabel,\nspan {\n  font-family: \"Poppins\";\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\" !important;\n}\n\na {\n  text-decoration: none !important;\n}\n\n/* Style for the dropdown container */\n.editdropdown {\n  position: relative;\n  display: inline-block;\n  /* z-index: 9; */\n}\n\n/* Style for the dropdown button */\n.editdropdown-button {\n  /* background-color:  rgb(240, 240, 240) ; */\n  color: #000000;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Style for the dropdown menu */\n.editdropdown-menu {\n  display: none;\n  left: -163px;\n  top: 0;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 190px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n/* Show the dropdown menu when the button is clicked */\n.editdropdown:hover .editdropdown-menu {\n  display: block;\n}\n\n/* Style for dropdown menu items */\n.editdropdown-menu a {\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.mandatory {\n  color: red;\n}\n\n.mandatorySimple::after {\n  content: \"*\";\n  color: red;\n}\n\n.jodit_sticky>.jodit-toolbar__box {\n  position: inherit !important;\n}\n\n/* Highlight dropdown menu items on hover */\n/* Style for the dropdown container */\n.editdropdownpage {\n  position: relative;\n  display: inline-block;\n}\n\n/* Style for the dropdown button */\n.editdropdownpage-button {\n  /* background-color:  rgb(240, 240, 240) ; */\n  color: #000000;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Style for the dropdown menu */\n.editdropdownpage-menu {\n  display: none;\n  left: -93px;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 100%;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n/* Show the dropdown menu when the button is clicked */\n.editdropdownpage:hover .editdropdownpage-menu {\n  display: block;\n}\n\n/* Style for dropdown menu items */\n.editdropdownpage-menu a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.mandatory {\n  color: red;\n}\n\n.notificationofwednesday {\n  position: fixed;\n  width: 100%;\n  z-index: 9999;\n  background: black;\n  color: white;\n}\n\n/* Highlight dropdown menu items on hover */\n.editdropdownpage-menu a:hover {\n  background-color: #f1f1f1;\n}\n\n.green-color {\n  color: #d3ffd3;\n}\n\n.green-color-bg {\n  background-color: #d3ffd3;\n}\n\n.yellow-color {\n  color: #fff8a6;\n}\n\n.dark-green {\n  color: green;\n}\n\n.PUBLISHED_active {\n  background: #d3ffd3;\n  color: green;\n  font-weight: 600;\n  font-size: 13px;\n  border-radius: 20px;\n  width: 120px;\n}\n\n.UNPUBLISHED_active {\n  background: #ffd9d9;\n  color: red;\n  font-weight: 600;\n  font-size: 13px;\n  border-radius: 20px;\n  width: 120px;\n}\n\n.ACTIVE_active {\n  background: #d3ffd3;\n  color: green;\n  font-weight: 600;\n  font-size: 13px;\n  border-radius: 20px;\n  width: 120px;\n}\n\n.In-ACTIVE_active {\n  background: #ffd9d9;\n  color: red;\n  font-weight: 600;\n  font-size: 13px;\n  border-radius: 20px;\n  width: 120px;\n}\n\n.DISABLED_active {\n  background: #ffea008a;\n  color: #000000;\n  font-weight: 600;\n  font-size: 13px;\n  border-radius: 20px;\n  width: 120px;\n}\n\n.tabHeading {\n  font-family: \"museo_sans500\" !important;\n  font-style: normal;\n  font-size: 16px !important;\n  color: #424242 !important;\n  background-color: transparent;\n  position: relative;\n  display: block;\n}\n\n.tabHeading.active {\n  font-family: \"museo_sans700\" !important;\n}\n\n.tabHeading.active::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  bottom: -9px;\n  left: 0;\n  border-radius: 10px;\n  height: 4px;\n  background-color: rgb(77, 77, 247);\n}\n\n.dashboard a {\n  text-decoration: none;\n  font-size: 16px;\n}\n\n.dashboard p {\n  color: #000000;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 18px;\n  text-transform: capitalize;\n  color: #161616;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 25px;\n  color: #646464;\n}\n\n.liveAlert.alert.alert-success.alert-dismissible.fade.show {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  z-index: 9999;\n}\n\n.liveAlert.alert.alert-danger.alert-dismissible.fade.show {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  z-index: 9999;\n}\n\n.banner-slider .modal {\n  top: 50px;\n}\n\n.delete_confirm {\n  margin-top: 10rem;\n}\n\n.success-message i {\n  font-size: 50px;\n  background-color: transparent;\n  border-radius: 50px;\n  border: 2px solid greenyellow;\n  color: greenyellow;\n}\n\n.css-1u9des2-indicatorSeparator {\n  width: 0px !important;\n}\n\nselect {\n  height: 50px;\n}\n\n.css-1xc3v61-indicatorContainer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition: color 150ms;\n  transition: color 150ms;\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\n  padding: 0px !important;\n  box-sizing: border-box;\n}\n\n.css-15lsz6c-indicatorContainer {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition: color 150ms;\n  transition: color 150ms;\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\n  /* padding: 0px !important; */\n  box-sizing: border-box;\n}\n\n.css-t3ipsp-control {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition: color 150ms;\n  transition: color 150ms;\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\n  padding: 0px !important;\n  box-sizing: border-box;\n}\n\n.css-1xc3v61-indicatorContainer svg {\n  width: 30px !important;\n  height: 15px !important;\n  top: 14px !important;\n}\n\n.css-15lsz6c-indicatorContainer svg {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg {\n  position: absolute;\n  right: 10px;\n  top: 11px;\n}\n\n.css-b62m3t-container {\n  /* height: 50px; */\n  /* border: 1px solid #e5e5ea !important; */\n  border-radius: 5px;\n  align-items: center;\n  padding: 5px 0 5px 0;\n}\n\n.css-13cymwt-control {\n  min-height: 45px !important;\n}\n\n.thumbnails-images {\n  width: auto;\n  height: 100px;\n}\n\n.thumbnails-upload-images {\n  width: 100%;\n  height: 65px;\n}\n\n#publish_time {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent !important;\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: transparent !important;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  border: 1px solid #e5e5ea !important;\n  height: 50px;\n}\n\n/* overlay.css */\n.overlay-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.overlay-icon {\n  font-size: 25px;\n  color: white;\n}\n\n.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg {\n  position: absolute;\n  right: 0px;\n  top: 11px;\n}\n\n.css-1fdsijx-ValueContainer {\n  padding: auto !important;\n}\n\n.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg path[d=\"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z\"] {\n  display: none;\n}\n\n.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg path[d=\"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z\"] {\n  display: none;\n}\n\n\nth {\n  text-align-last: start !important;\n  padding: 0;\n}\n\ntd {\n  text-align-last: start !important;\n  padding: 0;\n}\n\n/* New Header siderbar 28/8/2023 */\n/* New Header siderbar 28/8/2023 */\n/* Mobile view  */\n/* Custom, iPhone Retina */\n@media only screen and (min-width: 320px) {\n  .footerlink {\n    font-size: 15px;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n/* Extra Small Devices, Phones */\n@media only screen and (min-width: 480px) {\n  .footerlink {\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .footerlink {\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n/* Medium Devices, Desktops */\n@media only screen and (min-width: 992px) {\n  .footerlink {\n    font-size: 14px;\n    padding: 0;\n    margin: 0;\n  }\n}\n\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1200px) {}\n\n/* old codes */\n\n.errorred {\n  color: #ff2c2c !important;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.errorredspan {\n  position: absolute;\n  bottom: -18px;\n}\n\n.imageForm {\n  display: block;\n  position: absolute;\n  right: 16px;\n  z-index: 1;\n  bottom: 11px;\n  width: 80px;\n  height: 37px;\n  object-fit: cover;\n}\n\n#nestable>table {\n  overflow-x: auto;\n}\n\n.approveTable>table {\n  overflow-x: auto;\n}\n\n#videoPlayer {\n  width: 100%;\n  height: 100%;\n}\n\n.editVideoPlayer {\n  width: 125px !important;\n  height: 75px;\n}\n\n.status {\n  width: 80%;\n  font-weight: bold;\n  margin: 0 auto;\n  border-radius: 4px;\n}\n\n.closeBtn {\n  position: absolute !important;\n  right: 0;\n  top: 0px;\n  width: 40px;\n  background: transparent;\n  z-index: 100 !important;\n  height: 60px;\n}\n\n#PendingvideoPlayer {\n  width: 100%;\n  height: 80px;\n}\n\n.exportIcon {\n  width: 22px;\n  height: 18px;\n}\n\ninput[type=\"checkbox\"]:checked+label::before {\n  background-color: #00f;\n  border-color: #00f;\n}\n\n.idClass {\n  width: 80px !important;\n}\n\n.page-link {\n  transition: none !important;\n}\n\n.page-link:focus {\n  box-shadow: none !important;\n}\n\n.view-search {\n  background: rgba(250, 250, 250, 1);\n  border: 1px solid transparent;\n  height: 45px;\n  font-size: 14px;\n  width: 100%;\n  border-radius: 4px;\n  padding-left: 10px;\n  color: #646464 !important;\n}\n\n.filterContainer {\n  max-width: 270px;\n  width: 100%;\n  position: relative;\n}\n\n.hiddenExport {\n  display: none !important;\n}\n\n.video-overall-progress-li li {\n  list-style-type: none !important;\n}\n\n.filter:focus {\n  box-shadow: none !important;\n}\n\nselect#rating {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\n\nselect#trailer_type {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nselect#access {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nselect#url_type {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nselect#parent_id {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nselect#artist_type {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nselect#role_id {\n  border: 1px solid #e5e5ea !important;\n  border-radius: 5px !important;\n}\n\nli {\n  list-style-type: none;\n}\n\n.form-control.filter {\n  max-width: 270px;\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-position: 11px 13px;\n  padding: 8px 37px;\n  background-image: url(\"./components/Images/search_lens.png\");\n  transition: none !important;\n}\n\n.totalText {\n  /* font-family: \"museo_sans700\" !important; */\n  font-family: \"Poppins\" !important;\n  font-style: normal;\n  color: #424242 !important;\n  font-size: 20px;\n}\n\n/* Shared Icon Positioning for Inputs */\n.lockIcon,\n.eyeOpen,\n.eyeClosed {\n  font-size: 18px;\n  color: #000;\n}\n\n.lockIcon {\n  top: 15px;\n  left: 10px;\n}\n\n.passWordIcon {\n  top: 15px;\n  right: 17px;\n}\n\n.react-bootstrap-table th.sortable {\n  position: relative;\n}\n\n.react-bs-table-no-data {\n  text-align: center;\n}\n\n.commonActionPadding {\n  padding: 12px 16px;\n  cursor: pointer;\n}\n\n.modal.packageModel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9997;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n  background-color: rgb(0 0 0 / 41%);\n}\n\n.modal.season.packageModel {\n  z-index: 9996 !important;\n}\n\n.packageModel .btn-close:focus {\n  box-shadow: none;\n}\n\n.noRecord {\n  display: flex;\n  justify-content: center;\n  font-size: 17px;\n  font-weight: bold;\n  padding: 10px;\n}\n\n.dropzone {\n  background-position: left;\n  background-size: 75% !important;\n  background-repeat: no-repeat;\n  justify-content: flex-end !important;\n}\n\n.editFormImage {\n  max-width: 170px !important;\n  height: 100px;\n  object-fit: contain;\n  display: block;\n  margin: 8px 0px;\n}\n\n.videoPreview {\n  width: 80%;\n  margin-right: auto;\n  height: 100%;\n}\n\n.Toastify__toast {\n  border-radius: 16px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;\n  padding: 12px 16px !important;\n  min-height: 56px !important;\n}\n\n.Toastify__toast-body {\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  margin: 0 !important;\n  padding: 0 12px !important;\n}\n\n.Toastify__toast-icon {\n  width: 22px !important;\n  margin-inline-end: 12px !important;\n}\n\n.Toastify__progress-bar {\n  height: 3px !important;\n}\n\n.admin-sub-title {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  line-height: 15px;\n  font-weight: 600;\n  word-wrap: break-word;\n}\n\n.admin-sub-title {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  line-height: 15px;\n  font-weight: 600;\n  word-wrap: break-word;\n}\n\n.bootstrapTable table>thead>tr {\n  border: none;\n}\n\n.bootstrapTable table>thead>tr>th {\n  border: none;\n  font-size: 16px;\n  font-family: \"Poppins\" !important;\n  padding: 10px;\n  width: 130px;\n  font-weight: 500;\n  position: relative;\n}\n\n.bootstrapTable table>tbody>tr>td {\n  white-space: normal;\n  word-break: break-all;\n  border: none;\n  font-size: 15px;\n  font-family: \"Poppins\" !important;\n  padding: 10px;\n  width: 130px;\n  vertical-align: middle;\n}\n\n.bootstrapTable.multi-delete-width table>thead>tr>th:nth-child(1) {\n  width: 4%;\n}\n\n.bootstrapTable .video-width-table {\n  width: 200px;\n}\n\n.bootstrapTable .page-item.disabled>.page-link {\n  opacity: 0.5;\n}\n\n.videoWidth>th:nth-child(2) {\n  width: 30%;\n  position: relative;\n}\n\n.videoWidthpartner>th:nth-child(2) {\n  width: 10%;\n  position: relative;\n}\n\n.videoWidth>th:nth-child(2) span {\n  position: absolute;\n  right: 0;\n}\n\n.videoWidth>th {\n  width: 100px;\n}\n\n.sortable::after {\n  content: \"\\2193\";\n  color: #ccc;\n  padding: 0px 9px;\n  position: absolute;\n  right: 12px;\n  top: 3px;\n  font-size: 18px;\n}\n\n.sortable::before {\n  content: \"\\2191\";\n  color: #ccc;\n  position: absolute;\n  right: 12px;\n  top: 3px;\n  font-size: 18px;\n}\n\nth[aria-label=\"Audios sort asc\"].sortable::before {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Audios sort desc\"].sortable::after {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Access sort asc\"].sortable::before {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Access sort desc\"].sortable::after {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Videos sort asc\"].sortable::before {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Videos sort desc\"].sortable::after {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Upload by sort asc\"].sortable::before {\n  color: #0d6efd;\n}\n\nth[aria-label=\"Upload sort desc\"].sortable::after {\n  color: #fff;\n}\n\n.profile {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 3px;\n}\n\n.table-subheading {\n  font-size: 12px;\n}\n\n.rightVideoTitle {\n  width: 200px;\n}\n\n.sliderBtnText {\n  font-size: 13px !important;\n  font-family: \"Poppins\" !important;\n}\n\n.admin-button-text {\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 15px !important;\n  line-height: 20px !important;\n}\n\n.button-color {\n  color: #fff !important;\n}\n\n\n.admin-input-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.svgIcon {\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 0.75px;\n}\n\n.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-menu {\n  bottom: 32px;\n}\n\n.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-item>a {\n  display: block;\n}\n\n#pageDropDown {\n  transition: none !important;\n}\n\n#pageDropDown:focus {\n  box-shadow: none !important;\n}\n\n.react-bootstrap-table-page-btns-ul {\n  justify-content: end;\n}\n\n.clearBtn {\n  top: 10px;\n  position: absolute;\n  right: 0;\n  background: transparent;\n}\n\n.custom-close-btn {\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n}\n\n.adminHeadContainer {\n  min-height: calc(100vh - 120px);\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: 0.6s;\n  transition: all 0.4s;\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\ninput:checked+.slider {\n  background-color: #2196f3;\n}\n\ninput:focus+.slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 15px;\n  width: 15px;\n  left: 4px;\n  bottom: 3px;\n  background-color: white;\n  transition: all 0.4s;\n}\n\ninput:checked+.slider:before {\n  left: 26px;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 45px;\n  height: 20px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.custom-placeholder::placeholder {\n  font-family: \"Poppins\" !important;\n}\n\n.imagedropcopy {\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  border-style: dashed;\n  border-color: #cbd5e1;\n  cursor: pointer;\n  min-height: 70px;\n  height: auto;\n  width: 80%;\n}\n\n.imagedropcopyimage {\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  border-style: dashed;\n  border-color: #cbd5e1;\n  width: 100%;\n  cursor: pointer;\n}\n\n.admin-title {\n  font-size: 30px;\n  line-height: 40px;\n  font-weight: bold;\n}\n\n.customDropWrapper {\n  width: 100%;\n  height: 250px;\n  border: 2px dashed #ccc;\n  position: relative;\n}\n\n.customDropWrapper input {\n  opacity: 0;\n}\n\n.dropZoneText {\n  position: absolute;\n  top: 0;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  height: 100%;\n}\n\n.rowCheckboxDrag {\n  width: 4% !important;\n}\n\n.rowCheckboxfooterDrag {\n  width: 9% !important;\n}\n\n.category-order-title {\n  padding: 10px;\n  font-size: 16px;\n  white-space: normal;\n  word-break: break-all;\n  border: none;\n}\n\n.border-width {\n  border-width: 2px !important;\n}\n\n.border-solid-width {\n  border-width: 1px;\n}\n\n.orderHeading {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 37px;\n  font-family: 'Poppins';\n}\n\n.orderContainer>div:not(:nth-child(2), :nth-child(1), :nth-child(4)) {\n  width: 15%;\n}\n\n.orderContainer>div:nth-child(1) {\n  width: 5%;\n}\n\n.orderContainer>div:nth-child(2) {\n  width: 25%;\n}\n\n.orderContainer>div:nth-child(4) {\n  width: 15%;\n}\n\n.reloadButton {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-tool-tip-parent {\n  position: relative;\n}\n\n.custom-tool-tip-parent:hover .custom-tool-tip {\n  display: block !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.modal-description {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n}\n\n.imagedrop {\n  /* width: 100%; */\n  width: 80%;\n  height: 70px;\n  /* height: 120px; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  border-style: dashed;\n  border-color: #cbd5e1;\n  cursor: pointer;\n}\n\n.image-close {\n  position: absolute;\n  top: -16px;\n  right: -14px;\n  width: 22px !important;\n  height: 22px !important;\n  opacity: 1 !important;\n  border-style: dashed !important;\n  border-width: 2px !important;\n  border-color: #cbd5e1 !important;\n}\n\n.custom-input {\n  font-size: 13px;\n  padding: 15px 20px;\n  border-radius: 7px;\n  font-weight: 500;\n}\n\ninput[readonly]:focus {\n  outline: none;\n}\n\n.focus-hide:focus {\n  outline: 0;\n}\n\n.rti--container {\n  padding: 11px 15px !important;\n}\n\n.rti--tag>span {\n  padding: 4px 15px;\n  border-radius: 2px;\n}\n\n.rti--tag>button {\n  padding: 3px 5px !important;\n  border-radius: 0px !important;\n}\n\n\n.admin-input-description {\n  font-size: 13px;\n  min-width: 80px;\n}\n\n.copy-board-container {\n  cursor: pointer;\n  position: absolute;\n  top: -1px;\n  width: 55px;\n  right: -1px;\n  border-top-right-radius: 9px;\n  border-bottom-right-radius: 9px;\n  height: 51px;\n}\n\n.copy-board-input {\n  padding-right: 55px;\n}\n\n\n.copy-reply {\n  top: -45px;\n  right: 6px;\n}\n\n.tool-tip-text {\n  top: -44px;\n  padding: 10px;\n  left: 136px;\n  font-size: 10px;\n  border-radius: 6px;\n  width: 180px;\n  line-height: 15px;\n}\n\n.tool-tip-open:hover .tool-tip-text {\n  display: block !important;\n}\n\n.labelLoader {\n  width: 30%;\n  height: 20px;\n  border-radius: 3px;\n}\n\n.headingLoader {\n  width: 50%;\n  height: 35px;\n  border-radius: 3px;\n}\n\n.subHeadingLoader {\n  width: 40%;\n  height: 14px;\n  border-radius: 3px;\n}\n\n.square {\n  background: rgba(130, 130, 130, 0.2);\n  background: -webkit-gradient(linear,\n      left top,\n      right top,\n      color-stop(8%, rgba(130, 130, 130, 0.2)),\n      color-stop(18%, rgba(130, 130, 130, 0.3)),\n      color-stop(33%, rgba(130, 130, 130, 0.2)));\n  background: linear-gradient(to right,\n      rgba(130, 130, 130, 0.2) 8%,\n      rgba(130, 130, 130, 0.3) 18%,\n      rgba(130, 130, 130, 0.2) 33%);\n  background-size: 800px 100px;\n  animation: wave-squares 2s infinite ease-out;\n}\n\n@keyframes wave-squares {\n  0% {\n    background-position: -468px 0;\n  }\n\n  100% {\n    background-position: 468px 0;\n  }\n}\n\n.cancal-position {\n  top: 2px;\n  right: 5px;\n}\n\n.cancal-position>svg {\n  width: 15px;\n  height: 15px;\n}\n\n.progressHeight {\n  height: 30px;\n}\n\n.percentagePop {\n  top: 5px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 20px;\n  height: 10px;\n  border: 0;\n}\n\n.progressSmall {\n  height: 15px;\n}\n\n.progressSubText {\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 3px;\n}\n\n.progressButton {\n  font-size: 10px;\n  padding: 3px 13px;\n}\n\n.percentageText {\n  top: 0px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  font-size: 11px;\n  width: 20px;\n  height: 14px;\n  border: 0;\n}\n\n.progressFileNameElip {\n  width: 110px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.modal-large {\n  max-width: 800px !important;\n}\n\n.priceTable {\n  height: 300px;\n  overflow-y: overlay;\n}\n\n.priceTable thead {\n  position: sticky;\n  top: 0;\n}\n\n.AdminUploadIndicator {\n  position: fixed;\n  bottom: 50px;\n  right: 10px;\n  width: 400px;\n  z-index: 998;\n  border-top-left-radius: 25px;\n  border-top-right-radius: 25px;\n  height: auto;\n  max-height: 450px;\n  transition: height 1s ease;\n}\n\n.overflow-scroll-indicator {\n  overflow: hidden overlay;\n}\n\n.overflow-hidden-indicator {\n  overflow-x: hidden !important;\n}\n\n.upload-indicator-header {\n  top: 0;\n  z-index: 998;\n}\n\n.AdminUploadIndicator.collapse-zone {\n  height: 50px;\n}\n\n.indicator-width {\n  width: 200px;\n}\n\n.successFull {\n  background-color: #3cb043;\n}\n\n.indicator-file-name {\n  width: 200px;\n  height: 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.indicatorButon {\n  width: 58px;\n}\n\n.list-height {\n  height: 68px;\n}\n\n.cancelText {\n  font-size: 10px;\n}\n\n.sizeText {\n  font-size: 10px;\n  font-weight: bold;\n}\n\n.speedText {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.rotate-arrow {\n  transform: rotate(180deg);\n}\n\n.from-indicator {\n  padding: 2px 9px;\n  font-size: 8px;\n  top: -11px;\n  left: -2px;\n  background-color: rgb(241, 241, 115);\n}\n\n.galleryBox {\n  height: 400px;\n  overflow-y: scroll;\n}\n\n.galleryImage {\n  height: 150px;\n  object-fit: cover;\n}\n\n.galleryTitle {\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 20px;\n}\n\n.galleryDuration {\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.galleryButton {\n  width: 30px;\n  height: 30px;\n}\n\n.galleryAfter::after {\n  content: '' !important;\n  display: none !important;\n}\n\n.galleryCheckBox {\n  position: absolute;\n  top: 38px;\n  left: 37px;\n  height: 21px;\n  width: 21px;\n}\n\n.hideArrow::after {\n  border: none !important;\n}\n\n.custom-datepicker {\n  width: 250;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.custom-datepicker .rs-picker-toggle-value {\n  color: black !important;\n}\n\n.rs-picker-daterange-header {\n  display: none !important;\n}\n\n.z-index-1 {\n  z-index: 1;\n}\n\n.table-column-title.avoid-overflow-ellipsis {\n  text-overflow: unset;\n  overflow: unset;\n  white-space: unset;\n  max-width: unset;\n}\n\n@media screen and (max-width: 423px) {\n  .deleteBtn {\n    width: 100%;\n  }\n}\n\n.tooltip-disabled {\n  font-size: 11px;\n  background-color: #333;\n  color: #fff;\n  padding: 5px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  z-index: 9999 !important;\n}\n\n.custom-page-select {\n  background-color: #ffffff;\n  color: #000;\n}\n\nselect.select-view-type {\n  width: 100px !important;\n}\n\n.admin-tooltip {\n  border-radius: 6px;\n  white-space: nowrap;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.tooltip-container:hover .admin-tooltip {\n  pointer-events: auto;\n}\n\n.admin-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #000 transparent transparent transparent;\n}\n\n.tooltip-container .custom-hover-tooltip {\n  opacity: 0;\n  visibility: hidden;\n  transform: translateX(-50%) translateY(10px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  pointer-events: none;\n  position: absolute;\n  z-index: 9999;\n}\n\n.tooltip-container:hover .custom-hover-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(0);\n  pointer-events: auto;\n}\n\n.custom-hover-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #000 transparent transparent transparent;\n}\n\n.trailer-episode-image {\n  height: 50px;\n  width: 50px;\n  object-fit: cover;\n}\n\n.rtmpurleditbg :hover {\n  background-color: rgb(245, 247, 252) !important;\n}\n\n.logoPay {\n  width: 160px;\n  height: 50px;\n  object-fit: contain;\n}\n\n.drag-handle {\n  cursor: grab;\n  user-select: none;\n}\n\n.modalBackdropdataserviceunavailable {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #000000;\n  color: #ffffff;\n  opacity: 0.8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10007;\n}\n\n.modalContentdataserviceunavailable {\n  background-color: #000000;\n  color: #ffffff;\n  padding: 2rem;\n  opacity: 1;\n  border-radius: 10px;\n  max-width: 700px;\n  text-align: center;\n}\n\n.hide-checkbox-row td input[type=\"checkbox\"] {\n  display: none !important;\n}\n\n.counter_timing {\n  border-radius: 0.8em;\n  -moz-border-radius: 0.8em;\n  display: inline-block;\n  line-height: 1.6em;\n  margin-left: 20px;\n  text-align: center;\n  width: 1.6em;\n}\n\n\n.modern-modal {\n  border-radius: 20px !important;\n  padding: 10px 10px 20px;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.20);\n  border: none;\n}\n\n.modern-backdrop {\n  backdrop-filter: blur(4px);\n}\n\n.upgrade-btn {\n  background: linear-gradient(135deg, #ff8a00, #ff4d00);\n  color: #fff !important;\n  padding: 12px;\n  border-radius: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  display: inline-block;\n  transition: 0.2s ease;\n}\n\n.upgrade-btn:hover {\n  opacity: 0.9;\n}\n\n.modal-title {\n  font-size: 1.25rem;\n}\n\n.sub-page {\n  display: grid;\n  grid-template-columns: 3fr 1.3fr;\n  gap: 24px;\n}\n\n.sub-card,\n.checkout-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px 24px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n}\n\n.sub-title {\n  font-size: 26px;\n  font-weight: 800;\n  margin-bottom: 8px;\n  color: #111827;\n  letter-spacing: -0.5px;\n}\n\n.sub-tabs {\n  display: flex;\n  gap: 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tab {\n  padding: 10px 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #6b7280;\n  border-bottom: 2px solid transparent;\n}\n\n.tab.active {\n  color: #111827;\n  font-weight: 600;\n  border-color: #2563eb;\n}\n\n.tab-body {\n  padding-top: 20px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.subscription-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.label {\n  font-weight: 600;\n  color: #374151;\n}\n\n.badge {\n  background: #e5edff;\n  color: #2563eb;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.status-pill {\n  margin-left: auto;\n  background: #dcfce7;\n  color: #15803d;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.plans-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.plan-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.plan-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.plan-price {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.price {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.cycle {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.btn-outline {\n  margin-top: 8px;\n  width: 100%;\n  padding: 8px 0;\n  border-radius: 6px;\n  border: 1px solid #2563eb;\n  background: #fff;\n  color: #2563eb;\n  cursor: pointer;\n}\n\n.checkout-card h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.total-row span:last-child {\n  font-weight: 700;\n}\n\n.btn-primary.full {\n  margin-top: 20px;\n  width: 100%;\n  padding: 10px 0;\n  border-radius: 6px;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  cursor: pointer;\n}\n\n.addons-section {\n  margin-bottom: 24px;\n}\n\n.plans-grid.compact {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  row-gap: 10px;\n}\n\n.pricing-card.small {\n  flex: 0 0 240px;\n  max-width: 240px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 16px;\n  background: #fff;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.addons-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.addon-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 14px;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: all 0.2s ease-in-out;\n}\n\n.addon-card.purchased {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.addon-name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.addon-price {\n  margin: 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.purchased-badge {\n  background: #059669;\n  color: white;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.btn-outline-danger {\n  margin-top: 8px;\n  width: 100px;\n  padding: 8px 0;\n  border-radius: 6px;\n  border: 1px solid #dc2626;\n  color: #dc2626;\n  background: #fff;\n  cursor: pointer;\n}\n\n.save-tag {\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.14);\n  color: #047857;\n  font-weight: 600;\n}\n\n/* Existing pricing card styles (keep yours, add tweaks if needed) */\n.pricing-card.small {\n  width: 260px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 18px;\n  background: #fff;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.pricing-card.small:hover {\n  transform: translateY(-3px);\n  border-color: #2563eb;\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.07);\n}\n\n.pricing-card.small.active {\n  border: 2px solid #2563eb;\n  background: #eef4ff;\n}\n\n.card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.plan-name {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.plan-icon {\n  font-size: 22px;\n  color: #9ca3af;\n}\n\n.selected-icon {\n  font-size: 22px;\n  color: #2563eb;\n}\n\n.price-block {\n  margin-top: 10px;\n}\n\n.price-main {\n  font-size: 26px;\n  font-weight: 800;\n}\n\n.cycle {\n  font-size: 15px;\n  color: #6b7280;\n  margin-left: 4px;\n}\n\n.price-strike {\n  margin-top: 3px;\n  text-decoration: line-through;\n  color: #9ca3af;\n  font-size: 15px;\n}\n\n.addon-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);\n}\n\n.modern-select select {\n  padding-left: 36px;\n  border-radius: 10px;\n  font-size: 15px;\n}\n\n/* Wrapper prevents clipping */\n.dropdown-wrapper {\n  position: relative;\n  overflow: visible !important;\n}\n\n/* Dropdown container */\n.custom-dropdown {\n  position: relative;\n  width: 220px;\n}\n\n.dd-select {\n  padding-left: 40px !important;\n  padding-right: 40px !important;\n  border-radius: 12px !important;\n  height: 42px;\n  font-size: 15px;\n  background: #ffffff;\n  border: 1px solid #dcdcdc;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  appearance: none;\n  /* Hide default arrow */\n}\n\n/* Funnel icon */\n.dd-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n/* Custom arrow */\n.custom-dropdown::after {\n  content: \"▼\";\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 10px;\n  color: #6c757d;\n  pointer-events: none;\n}\n\n/* Focus highlight */\n.dd-select:focus {\n  border-color: #4e74ff !important;\n  box-shadow: 0 0 0 3px rgba(78, 116, 255, 0.25) !important;\n}\n\n/* Ensure dropdown never gets cut */\nselect {\n  overflow: visible !important;\n}\n\n.dropdown-menu {\n  z-index: 9999 !important;\n}\n\n.subscription-container {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 28px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.sub-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sub-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.status-badge {\n  padding: 6px 14px;\n  font-size: 13px;\n  border-radius: 12px;\n  background: #e0fbe8;\n  color: #15803d;\n  font-weight: 600;\n}\n\n.plan-card-modern {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f9ff;\n  border: 1px solid #e1e6ff;\n  padding: 18px 20px;\n  border-radius: 12px;\n}\n\n.plan-label {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 2px;\n}\n\n.plan-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e3a8a;\n}\n\n.plan-tag {\n  padding: 6px 14px;\n  font-size: 12px;\n  background: #eef2ff;\n  color: #4338ca;\n  border-radius: 12px;\n  font-weight: 600;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 18px;\n}\n\n.info-item {\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  padding: 14px 16px;\n  border-radius: 12px;\n}\n\n.info-item.full {\n  grid-column: 1 / -1;\n}\n\n.info-label {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #6b7280;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\n.info-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.divider {\n  border: none;\n  border-top: 1px solid #e5e7eb;\n  margin: 10px 0;\n}\n\n.checkout-card-modern {\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 20px 22px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  border: 1px solid #f0f2f5;\n}\n\n.checkout-title {\n  font-size: 19px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.checkout-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  font-size: 14px;\n}\n\n.value {\n  font-weight: 600;\n}\n\n.total-row .value.total {\n  font-size: 18px;\n  color: #111;\n  font-weight: 700;\n}\n\n.divider-light {\n  border-top: 1px dashed #ddd;\n  margin: 10px 0;\n}\n\n.highlight-row {\n  background: #f9f2ff;\n  padding: 8px 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  color: #6a00ff;\n}\n\n.subtle-row {\n  color: #555;\n  font-size: 13.5px;\n}\n\n.next-billing-text {\n  margin-top: 6px;\n  font-size: 12.5px;\n  color: #666;\n}\n\n.cancel-btn {\n  background: #e63946;\n  color: white;\n  padding: 10px 18px;\n  border-radius: 8px;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.cancel-btn:hover {\n  background: #d62828;\n}\n\n.disabled-card {\n  cursor: not-allowed !important;\n  border-color: #d1d5db !important;\n  pointer-events: none;\n}\n\n.disabled-card:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.purchased-pill {\n  background: #10b981;\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.pricing-header-v3 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n}\n\n.pricing-title-v3 {\n  font-size: 26px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pricing-subtitle-v3 {\n  font-size: 14px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.pricing-switch-group-v3 {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.currency-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding: 10px 42px 10px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  background: #ffffff;\n  border: 2px solid #e2e8f0;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);\n  color: #0f172a;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='%2367768a' width='16' height='16' viewBox='0 0 24 24'><path d='M7 10l5 5 5-5'/></svg>\");\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n}\n\n.currency-select:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n}\n\n.currency-select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n  outline: none;\n}\n\n.currency-select option {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 8px;\n}\n\n.billing-toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background: #f1f5f9;\n  border-radius: 999px;\n  padding: 6px;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.toggle-btn {\n  position: relative;\n  z-index: 2;\n  border: none;\n  background: none;\n  padding: 10px 26px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  border-radius: 999px;\n  white-space: nowrap;\n  transition: color 0.25s ease;\n}\n\n.toggle-btn.active {\n  color: #fff;\n  font-weight: 700;\n}\n\n.toggle-highlight {\n  position: absolute;\n  top: 6px;\n  bottom: 6px;\n  background: linear-gradient(135deg, #6366f1, #7c3aed);\n  border-radius: 999px;\n  box-shadow: 0px 6px 22px rgba(99, 102, 241, 0.35);\n  z-index: 1;\n  transition: all 0.28s ease;\n}\n\n.toggle-left {\n  transform: translateX(0%);\n  width: calc(50% - 6px);\n}\n\n.toggle-right {\n  transform: translateX(100%);\n  width: calc(50% - 6px);\n}\n\n.baseservices-section {\n  padding: 30px 15px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.baseservices-title {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.baseservices-subtitle {\n  color: #777;\n  margin-bottom: 32px;\n}\n\n.baseservices-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.baseservice-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 24px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  transition: 0.3s ease;\n}\n\n.baseservice-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.1);\n}\n\n.baseservice-card h3 {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 12px 0 10px;\n}\n\n.baseservice-card p {\n  color: #666;\n  font-size: 14px;\n  line-height: 1.6;\n  flex-grow: 1;\n}\n\n.baseservice-btn-wrap {\n  margin-top: 18px;\n}\n\n.baseservice-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: #fff;\n}\n\n.baseservice-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  text-decoration: none;\n  transition: 0.3s ease;\n}\n\n.baseservice-btn .arrow {\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n\n.baseservice-btn:hover .arrow {\n  transform: translateX(6px);\n}\n\n.baseservice-btn:hover {\n  color: #fff;\n}\n\n.flicknexs {\n  background: #2563eb;\n  color: #fff;\n}\n\n.flicknexs:hover {\n  background: #2563eb;\n  color: #fff;\n}\n\n.purple {\n  background: #7c3aed;\n}\n\n.primary {\n  background: #2563eb;\n}\n\n.warning {\n  background: #f97316;\n}\n\n.dark {\n  background: #111827;\n}\n\n.success {\n  background: #16a34a;\n}\n\n.info {\n  background: #6366f1;\n}\n\n.danger {\n  background: #db2777;\n}\n\n.adminforgot .model-x-button button {\n  font-size: 13px;\n  right: 5px;\n  top: 5px;\n}\n\n\n@media (max-width: 900px) {\n  .sub-page {\n    grid-template-columns: 1fr;\n  }\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
